import {KODATA_AVG_SALES_RANGE} from '@/constants';
import {KodataStoresQueryFilters} from '@/map/enums';
import {toStringFromRange} from '@/map/utils';
import {Flexbox, FlexFullGrow} from '@/styled-components';
import {
  FilterOptionButton, FilterOptionButtonGroup, OptionLabel, OptionName
} from '../StyledComponents';

interface IProps {
  initialValues: typeof KODATA_AVG_SALES_RANGE;
  onChange(key: KodataStoresQueryFilters, value: any): void;
}

export const AvgSalesFilter = ({initialValues, onChange}: IProps) => {
  return (
    <div>
      <Flexbox>
        <OptionName>최근 3개월 월 평균 매출액</OptionName>
        <FlexFullGrow />
        <OptionLabel>다중 선택</OptionLabel>
      </Flexbox>
      <FilterOptionButtonGroup>
        {KODATA_AVG_SALES_RANGE.map((i) => (
          <FilterOptionButton
            key={i.join('~')}
            active={
              initialValues?.findIndex((x) => x.join('~') === i.join('~')) >= 0
            }
            onClick={() => onChange(KodataStoresQueryFilters.salesRanges, i)}
          >
            {toStringFromRange(i, '')}
          </FilterOptionButton>
        ))}
      </FilterOptionButtonGroup>
    </div>
  );
};
